export const NewsletterPopupMock = {
  headline: 'Join our Air Wick community today',
  description: 'Enter your details to subscribe to our emails.',
  thankYou: {
    headline: 'Thank you for subscribing to the Air Wick newsletter!',
    description: '',
    closeButton: {
      label: 'Close',
      redirectUrl: '/',
    },
  },
  form: {
    id: 'b7bd81af-21c5-4c65-806b-f9d714c104b6',
    url: 'https://phx-promoplatform-api-pl-prod.promoplatform.rbcloud.io/api/v1/external/forms',
    submitErrorMessage: 'Please fill in the required fields.',
  },
};
